<template>
  <div class="px-page mb-8 text-center py-12">
    <div class="flex flex-col items-center justify-center min-h-[60vh]">
      <div class="mb-8">
        <ArrowPathIcon class="animate-spin h-16 w-16 text-primary-600 mx-auto" aria-hidden="true" />
      </div>

      <div class="text-3xl font-extrabold tracking-tight sm:text-4xl">
        <span class="block text-gray-900">Processing order</span>
        <span class="block text-primary-600 mt-2">{{ order_number }}</span>
      </div>

      <div class="mt-8 max-w-md">
        <p class="text-lg text-gray-500">
          Please wait while we prepare your order for quality assurance.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import { router } from "@inertiajs/vue3";
import { ArrowPathIcon } from "@heroicons/vue/24/outline";

const props = defineProps({
  order_number: {
    type: String,
    required: true,
  },
  status: {
    type: String,
    default: 'processing',
  },
});

let pollingInterval = null;

const pollOrderStatus = () => {
  router.reload({
    only: ['status'],
    preserveScroll: true,
    preserveState: true,
    onSuccess: (page) => {
      const status = page.props.status;

      // If status changed from processing, redirect to order page
      if (status && status !== 'processing') {
        clearPolling();
        router.visit(route('qa.order', props.order_number));
      }
    },
  });
};

const clearPolling = () => {
  if (pollingInterval) {
    clearInterval(pollingInterval);
    pollingInterval = null;
  }
};

onMounted(() => {
  // Start polling every 2 seconds
  pollingInterval = setInterval(pollOrderStatus, 2000);
});

onUnmounted(() => {
  clearPolling();
});
</script>